import { toast } from "sonner";
import { FileText } from "lucide-react";
import { buildAnalysis, generateLaudo, isStale } from "../../lib/laudo";
import { fmtDate } from "../../lib/model";
import { LaudoDocument } from "../laudo/LaudoDocument";
import { StepTitle, Panel, ActionButton, Field, TextArea } from "../common/Field";

export default function Step8Laudo({ insp, update, save, photos }) {
  const laudo = insp.laudo;
  const generate = async () => {
    const analysis = !insp.analysis || isStale(insp) ? buildAnalysis(insp) : insp.analysis;
    const next = generateLaudo(insp, analysis, insp.laudo || {});
    update("analysis", analysis);
    update("laudo", next);
    await save(true, { analysis, laudo: next });
    toast.success("Laudo técnico gerado");
  };
  const set = (k) => (v) => update("laudo", (prev) => ({ ...prev, [k]: v }));

  return (
    <div className="flex flex-col gap-6">
      <StepTitle n={8} title="Laudo técnico" subtitle="Gerado automaticamente por regras a partir dos dados registrados. A conclusão e as recomendações podem ser revisadas pelo responsável técnico."
        actions={<ActionButton icon={FileText} onClick={generate} testId="btn-gerar-laudo">Gerar laudo</ActionButton>} />
      {!laudo && <Panel testId="laudo-empty"><p className="text-slate-400 text-sm">Clique em <b className="text-[#FFD500]">GERAR LAUDO</b>. Se a análise não existir ou estiver desatualizada, ela será gerada automaticamente.</p></Panel>}
      {laudo && (
        <div className="grid 2xl:grid-cols-[1fr_380px] gap-6 items-start">
          <div className="overflow-x-auto"><LaudoDocument insp={insp} photos={photos} analysis={insp.analysis} laudo={laudo} /></div>
          <Panel title="Revisão do texto" subtitle={`Gerado em ${fmtDate(laudo.generated_at)}`} testId="panel-laudo-edit" className="2xl:sticky 2xl:top-24">
            {isStale(insp) && <div className="mb-3 text-xs text-amber-300 border border-amber-500/40 bg-amber-500/10 px-3 py-2 rounded-sm" data-testid="laudo-stale">Dados alterados após a geração. Gere o laudo novamente.</div>}
            <div className="flex flex-col gap-4">
              <Field label="Conclusão técnica"><TextArea testId="laudo-conclusao-input" rows={8} value={laudo.conclusao} onChange={set("conclusao")} /></Field>
              <Field label="Recomendações (uma por linha)"><TextArea testId="laudo-recomendacoes-input" rows={6} value={laudo.recomendacoes} onChange={set("recomendacoes")} /></Field>
              <Field label="Observações complementares"><TextArea testId="laudo-observacoes-input" rows={3} value={laudo.observacoes} onChange={set("observacoes")} /></Field>
            </div>
          </Panel>
        </div>
      )}
    </div>
  );
}
